<template>
  <section>
    <div v-if="isLoading">
      <div class="p-5">
        <loader/>
      </div>
    </div>

    <div v-if="professionalPhotos.length > 0">
      <!-- Mobile View -->
      <section v-if="$mq.phone || professionalPhotos.length < numPhotos">
        <div class="section-experience-photos" @mouseover="mouseOver" @mouseout="mouseOut">
          <div class="cover-experience-photo bg-dark">
            <img v-lazy="professionalPhotos[0].image_xl"
                 :alt="professionalPhotos[0].title"
                 class="img-experience-photo"
                 :class="{'img-experience-effect': isHovered}"
                 @click="openGallery(0)">
          </div>
          <div class="section-view-photos p-2">
            <div class="bg-white border border-dark rounded py-2 px-3 text-small" @click="openGallery(0)">
              <i class="fas fa-th"></i>&nbsp;{{ $t('message.professional.menu.view_photos') }}
            </div>
          </div>
        </div>
      </section>
      <!-- Desktop View -->
      <section v-else>
        <div class="section-experience-photos" @mouseover="mouseOver" @mouseout="mouseOut">
          <div class="main-grid-experience-photos h-100">
            <div class="first-col-experience-photos bg-dark" style="border-right: 4px solid white;">
              <img v-lazy="professionalPhotos[0].image_xl"
                   :alt="professionalPhotos[0].title"
                   class="img-experience-photo"
                   :class="{'img-experience-effect': isHovered}"
                   @click="openGallery(0)">
            </div>
            <div style="border-left: 4px solid white;">
              <div class="second-col-experience-photos">
                <template v-for="(photo, index) in professionalPhotos" v-if="index > 0 && index < numPhotos">
                  <div class="sub-grid-experience-photos bg-dark"
                       :class="[index === 2 ? 'rounded-top-right' : '',
                              index === 4 ? 'rounded-bottom-right' : '']">
                    <img v-lazy="photo.image_sm"
                         :alt="photo.title"
                         class="img-experience-photo"
                         :class="{'img-experience-effect': isHovered}"
                         @click="openGallery(index)">
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="section-view-photos p-2">
            <div class="bg-white border border-dark rounded py-2 px-3 text-small" @click="openGallery(0)">
              <i class="fas fa-th"></i>&nbsp;{{ $t('message.professional.menu.view_photos') }}
            </div>
          </div>
        </div>

      </section>
    </div>
    <!-- Gallery -->
    <Tinybox v-model="galleryIndex" :images="photoUrls" loop no-thumbs />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import Loader from '../../loader/Loader'

export default {
  props: ['professional'],
  components: {
    Loader
  },
  data () {
    return {
      show: false,
      showTopNav: false,
      galleryIndex: null,
      options: { continuous: false },
      professionalPhotos: [],
      photoUrls: [],
      isHovered: false,
      numPhotos: 5,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser'
    })
  },
  methods: {
    mouseOver () {
      this.isHovered = true
    },
    mouseOut () {
      this.isHovered = false
    },
    async loadProfessionalPhotos () {
      const url = `/professionals/${this.professional.id}/photos`
      const {data} = await axios.get(url)
      this.isLoading = false
      if (!data.error) {
        this.professionalPhotos = data.photos
        for (const photo of this.professionalPhotos) {
          this.photoUrls.push(photo.image_xl)
        }
      }
    },
    updateFavProfessional (status) {
      if (this.user) {
        const submitData = {
          user_id: this.user.id,
          professional_id: this.professional.id
        }
        if (status) {
          this.$store.dispatch('user/ADD_FAVORITE_PROFESSIONAL', submitData)
        } else {
          this.$store.dispatch('user/DELETE_FAVORITE_PROFESSIONAL', submitData)
        }
        this.$store.commit('professional/UPDATE_FAVORITE_PROFESSIONAL', status)
      }
    },
    openGallery (index) {
      this.galleryIndex = index
    }
  },
  mounted () {
    this.loadProfessionalPhotos()
  },
  created () {
    this.isLoading = true
  }
}
</script>



// WEBPACK FOOTER //
// src/components/professional/components/CleanerPhotos.vue